import { API_BASE_URL } from "./backendConfig";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface KeywordRow {
  keyword: string;
  volume: string;
  difficulty: string;
  intent: string;
  relevance: string;
}

export interface ResearchStagePayload {
  status: "waiting_for_approval";
  stage: "research_approval_node";
  thread_id: string;
  topic: string | null;
  research_summary: string;
  suggested_topic: string;
  suggested_topics: string[];
  keyword_table: KeywordRow[];
  keywords: string[];
}

export interface TitleStagePayload {
  status: "waiting_for_approval";
  stage: "title_approval_node";
  thread_id: string;
  topic: string;
  title_options: string[];
  title_options_numbered: Record<string, string>;
}

export interface DraftStagePayload {
  status: "waiting_for_approval";
  stage: "human_approval_node";
  thread_id: string;
  topic: string;
  selected_title: string;
  blog_draft: string;
  keywords: string[];
}

export interface PublishedPayload {
  status: "published";
  thread_id: string;
  topic: string;
  selected_title: string;
  publish_result: string;
  blog_draft: string;
}

export type BlogPayload =
  | ResearchStagePayload
  | TitleStagePayload
  | DraftStagePayload
  | PublishedPayload;

// ─── API calls ────────────────────────────────────────────────────────────────

async function post<T>(path: string, body: object): Promise<T> {
  const res = await fetch(`${API_BASE_URL}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => String(res.status));
    throw new Error(`${path} failed (${res.status}): ${text}`);
  }
  return res.json() as Promise<T>;
}

/** Start the blogging agent. Uses Firebase session cookie — no secret needed. */
export function startBlog(topic?: string): Promise<BlogPayload> {
  return post<BlogPayload>("blog-start", { topic: topic ?? "" });
}

/** Resume the agent after a human decision. */
export function reviewBlog(body: {
  thread_id: string;
  action: string;
  selection?: string;
  feedback?: string;
}): Promise<BlogPayload> {
  return post<BlogPayload>("review-blog", body);
}
